import {
    is3rdPartyWorkflow, isPickPack
}                         from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {itemEditor, ui}   from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {PaperType} from "./ui/paper-type";

export const paperTypeModules = ({templateOptions}) => [
    {
        load: ({paperType2, method, totalQuantity, paperPrices, variationsPricing}, rootNext) => cs(
            ["eh", (_, next) => ErrorHighlighter({next})],
            ["domRef", (_, next) => Static2({next})],
            ({eh, domRef}) => rootNext((() => {
                if (!paperType2) {
                    return null;
                }
                const {state, paperTypes, paperType, finishing, finishingTypes,} = paperType2;

                const errorMessage = (
                    variationsPricing ? null : (
                        !paperType ? (
                            (isPickPack(templateOptions) || is3rdPartyWorkflow(templateOptions)) ? (
                                "Pricing has not been configured for this product"
                            ) : (
                                "No paper type has been set for this delivery option"
                            )
                        ) : (
                            !paperPrices ? (
                                "Invalid pricing"
                            ) : (
                                null
                            )
                        )
                    )
                );

                return {
                    itemEditor: {
                        $name: "paper type",
                        ...errorMessage ? {
                            errorsHandling: {
                                errorMessage,
                                highlightErrors: () => {
                                    eh.start();
                                    scrollIntoView(domRef.get());
                                },
                            },
                        } : {
                            valid: true,
                        },
                    },
                    ui: method === "download" ? null : (
                        ({className, templateBack, templateBackId, oia, templateOptions,}) => PaperType({
                            state,
                            paperTypes, paperType, finishing, finishingTypes,
                            totalQuantity,

                            className,
                            templateBack,
                            templateBackId,
                            oia,
                            templateOptions,

                            errorMessage,
                            paperTypeEh: eh,
                            paperTypeErrDomRef: domRef,
                        })
                    ),
                };
            })()),
        ),
        requires: ["paperType2", "method", "totalQuantity", "paperPrices"],
        requiresOptional: ["variationsPricing"],
        expo: [itemEditor, ui("paperType")],
    },
];
